import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
import _createClass from '/app/node_modules/babel-runtime/helpers/createClass';
export var NotificationApi = function () {
  function NotificationApi(axios, store) {
    _classCallCheck(this, NotificationApi);

    this.axios = axios;
  }

  _createClass(NotificationApi, [{
    key: 'getNotificationsCount',
    value: function getNotificationsCount() {
      // return Promise.resolve(45)
      return this.axios.$get('/notification/notification/getCount');
    }
  }, {
    key: 'markNotificationAsRead',
    value: function markNotificationAsRead(idNotification) {
      return this.axios.$patch('/notification/notification/mark-as-read/' + idNotification);
    }
  }]);

  return NotificationApi;
}();


//////////////////
// WEBPACK FOOTER
// ./src/api/notification.js
// module id = ./src/api/notification.js
// module chunks = 34